
















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import axios from "@/plugins/axios";
import { GetIdArr } from "@/utils/base";
import { GetFeedbackList } from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any[] = [];
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private go() {
    this.$router.push("/main/manage/list");
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
        search: this.filters.search,
      },
    };
    if (this.filters["需求有无"]) {
      params.params.else_need = this.filters["需求有无"];
    }
    localStorage.setItem("feedbackFilter", JSON.stringify(this.filters));
    GetFeedbackList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("feedbackFilter")) {
      this.filters = JSON.parse(localStorage.getItem("feedbackFilter") as any);
    }
    this.getList();
  }
}
